export const FETCH_SL_ADMIN_ACCOUNTS = 'FETCH_SL_ADMIN_ACCOUNTS';
export const FETCH_SL_ADMIN_ACCOUNTS_SUCCESS = 'FETCH_SL_ADMIN_ACCOUNTS_SUCCESS';
export const FETCH_SL_ADMIN_ACCOUNTS_FAILURE = 'FETCH_SL_ADMIN_ACCOUNTS_FAILURE';

export const IMPORTING_SL_ADMIN_ACCOUNTS = 'IMPORTING_SL_ADMIN_ACCOUNTS';
export const IMPORTING_SL_ADMIN_ACCOUNTS_SUCCESS = 'IMPORTING_SL_ADMIN_ACCOUNTS_SUCCESS';
export const IMPORTING_SL_ADMIN_ACCOUNTS_FAILURE = 'IMPORTING_SL_ADMIN_ACCOUNTS_FAILURE';

export const FETCH_SL_ACCOUNTS = 'FETCH_SL_ACCOUNTS';
export const FETCH_SL_ACCOUNTS_SUCCESS = 'FETCH_SL_ACCOUNTS_SUCCESS';
export const FETCH_SL_ACCOUNTS_FAILURE = 'FETCH_SL_ACCOUNTS_FAILURE';

export const FETCH_SL_VIEWS = 'FETCH_SL_VIEWS';
export const FETCH_SL_VIEWS_SUCCESS = 'FETCH_SL_VIEWS_SUCCESS';
export const FETCH_SL_VIEWS_FAILURE = 'FETCH_SL_VIEWS_FAILURE';

export const FETCHING_INITIAL_DATA_FOR_ADD_EDIT_MODAL = 'FETCHING_INITIAL_DATA_FOR_ADD_EDIT_MODAL';
export const FETCHING_INITIAL_DATA_FOR_ADD_EDIT_MODAL_FINISHED = 'FETCHING_INITIAL_DATA_FOR_ADD_EDIT_MODAL_FINISHED';
